
























  import Vue from 'vue';
  import { Component, Mixins, Prop } from 'vue-property-decorator';
  import { ListItem } from '../utils/types';
  import { toKebabCase } from '../utils/string';
  import { dynamicPropsMixin } from './dynamic-props.mixin';

  /**
   * It renders a list of {@link ListItem} providing a slot for each `slotName` which depends on
   * the `modelName`of the item.
   *
   * @public
   */
  @Component
  export default class ItemsList extends Mixins(dynamicPropsMixin(['itemClass'])) {
    /**
     * Animation component that will be used to animate the list.
     *
     * @public
     */
    @Prop({ default: 'ul' })
    protected animation!: Vue | string;

    /**
     * List of items.
     *
     * @public
     */
    @Prop({ required: true })
    protected items!: ListItem[];

    /**
     * The list of the items with additional properties.
     *
     * @returns A list of items with `dataTest`, `class` and the `slotName` for each item.
     *
     * @internal
     */
    protected get computedItems(): {
      dataTest: string;
      class: Array<string | undefined>;
    }[] {
      return this.items.map(item => {
        const modelName = toKebabCase(item.modelName);
        return {
          ...item,
          dataTest: `${modelName}s-list-item`,
          class: [`x-${modelName}s-list-item`, this.itemClass],
          slotName: modelName
        };
      });
    }
  }
